export class ComponentsMessages {
    //LOGIN
    public static REGISTER_MESSAGE = 'Register your account';
    public static REGISTER_DETAILS_MESSAGE = ' Please enter the username and the temporary password that was emailed to you';
    //ERROR PAGES
    public static BACK_TO_DASHBOARD = 'Back to Dashboard';
    public static BACK_TO_LENDERSLIST = 'Back to LendersList';

}